<template>
  <nav class="navbar">
    <div class="logo">
      <img src="@/assets/image/logo.jpg" alt="Project Logo" />
      <span class="company-name">河南百亩林农业科技发展有限公司</span>
    </div>
    <div class="menu-toggle" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="nav-links" :class="{ 'nav-active': isMenuOpen }">
      <button @click="navigateTo('/')">首页</button>
      <button @click="navigateTo('/product')">企业产品</button>
      <button @click="navigateTo('/news')">新闻动态</button>
      <button @click="navigateTo('/ourselves')">联系我们</button>
      <button @click="navigateTo('/honour')">荣誉与资质</button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    navigateTo(path) {
      this.$router.push(path);
      this.isMenuOpen = false; // 导航后关闭菜单
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: white;
  color: white;
  z-index: 1000;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  padding: 0 20px;
  box-sizing: border-box;
}

.logo {
  display: flex;
  align-items: center;
  margin-left: 20px;
  max-width: 40%;
  overflow: hidden;
}

.logo img {
  height: 60px;
  width: 60px;
  flex-shrink: 0;
}

.company-name {
  font-family: 'Brush Script MT', cursive;
  font-size: 24px;
  color: #333;
  margin-left: 10px;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-links {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.nav-links button {
  background-color: white;
  color: #333;
  border: none;
  padding: 0 15px;
  margin-left: 10px;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.3s ease;
  font-size: 16px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
}

.nav-links button:hover {
  background-color: green; /* 悬停时的背景颜色 */
  color: white; /* 悬停时的文字颜色 */
}

.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  cursor: pointer;
}

.menu-toggle span {
  display: block;
  height: 3px;
  width: 100%;
  background-color: #333;
  border-radius: 3px;
  transition: all 0.3s ease;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .navbar {
    height: 60px;
    padding: 0 15px;
  }

  .logo {
    margin-left: 10px;
    max-width: 70%;
  }

  .logo img {
    height: 40px;
    width: 40px;
  }

  .company-name {
    font-size: 18px;
    margin-left: 8px;
  }

  .menu-toggle {
    display: flex;
  }

  .nav-links {
    position: fixed;
    top: 60px;
    left: -100%;
    width: 100%;
    height: calc(100vh - 60px);
    background-color: white;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    transition: all 0.3s ease;
  }

  .nav-links.nav-active {
    left: 0;
  }

  .nav-links button {
    width: 80%;
    height: 50px;
    margin: 10px 0;
    font-size: 16px;
  }
}

@media screen and (max-width: 480px) {
  .navbar {
    height: 50px;
    padding: 0 10px;
  }

  .logo {
    margin-left: 5px;
    max-width: 75%;
  }

  .logo img {
    height: 35px;
    width: 35px;
  }

  .company-name {
    font-size: 16px;
    margin-left: 6px;
  }

  .menu-toggle {
    width: 25px;
    height: 18px;
  }

  .nav-links {
    top: 50px;
    height: calc(100vh - 50px);
  }

  .nav-links button {
    width: 90%;
    height: 45px;
    margin: 8px 0;
    font-size: 14px;
  }
}
</style>